import React, { useEffect, useState } from 'react'
import { errorToast } from '../Common/showtoast';
import { useNavigate, useParams } from 'react-router-dom';
import ApiRequest from '../Common/restservice';
import moment from 'moment';
const modes = {
    "team" : "TB",
    "global" : "GB",
    "royalty" : "R",
    "directincentive" : "I",
    "teamincentive" : "TI"
}
function ROIDincomeReport() {
    const navigate = useNavigate();
    const [tableData, setTableData] = useState([]);
    const {cdate,mode} = useParams();
    useEffect(() => {
        console.log(cdate);
        GetTransactions();
    }, [cdate,mode])
    const GetTransactions = async () => {
        let res = await ApiRequest("reward_details.asp", "POST", { payoutdate : cdate ? moment(cdate,'DD_MM_YYYY').format("MM/DD/YYYY") : "",pageno:1,modes:modes[mode] }, { Authorization: localStorage.getItem("token") });
        if (res.status === "error") {
            errorToast(res.message);
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        setTableData(res.items);
    }
    return (
        <section className="content">
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-1" style={{ fontWeight: "200", fontSize: "22px" }}>
                                {mode?.toUpperCase()} Income
                            </h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-vcenter text-nowrap mb-0 table-bordered border-top" style={{ textAlign: "center" }}>
                                    <thead className="">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Userid</th>
                                            <th>User Name</th>
                                            <th>Package</th>
                                            <th>Payout</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            tableData.length <= 0 ? <tr>
                                                <td colSpan="5">No Details Found</td>
                                            </tr> :
                                                tableData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{(index + 1)}</td>
                                                        <td>{item.date}</td>
                                                        <td>{item.businessid}</td>
                                                        <td>{item.businessidName}</td>
                                                        <td>{item.business}</td>
                                                        <td>{item.payout}</td>
                                                    </tr>
                                                ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ROIDincomeReport
